
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { fetchJobUnlock, fetchSetJobEditCancel, fetchSetJobLock } from '@/helpers/fetchers';
import { JobEditCancelParams, JobComplianceData } from '@/models/JobComplianceTypes';
import { User } from '@/models/main';
import { mapState } from 'vuex';
import { JobLockError, ValidationAPIError } from '@/helpers/throwables';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  components: {
    Icon,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class JobCancel extends Vue {
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  private user!: User;
  public loading = false;

  public cancel_name = '';
  public cancel_reason = '';

  public async setJobAsCancelClicked(): Promise<void> {
    const form = this.$refs.formCancel as HTMLFormElement;
    if (form) {
      const success = await form.validate();
      if (success) {
        this.loading = true;

        await fetchSetJobLock(this.formData.rockhopper_id, this.formData.rockhopper_date)
          .then(async () => {
            const params: JobEditCancelParams = {
              actor: this.cancel_name,
              reason: this.cancel_reason,
            };
            await fetchSetJobEditCancel(this.formData.rockhopper_id, this.formData.rockhopper_date, params)
              .then(() => {
                this.cancel_name = '';
                this.cancel_reason = '';
                this.$emit('fetchData');
              })
              .catch(async err => {
                // In case of validation error, unlock the job
                if (err instanceof ValidationAPIError) {
                  await fetchJobUnlock(this.formData.rockhopper_id, this.formData.rockhopper_date);
                  notifyNetworkError({ text: err.message });
                }
              });
          })
          .catch(err => {
            if (err instanceof JobLockError) {
              return;
            }
          });

        this.loading = false;
      }
    }
  }
}
